// extracted by mini-css-extract-plugin
module.exports = {"button":"DashboardButton_button__XFNa8","button_icon_withAnimation":"DashboardButton_button_icon_withAnimation__31Nyk","button_icon":"DashboardButton_button_icon__28uPL"};